/* Copyright (c) 2022 Xperi. All Rights Reserved. */

export class LocationUrls {
    static GUIDE = '/guide';

    static ERROR_SCREEN = '/error';

    static SETTINGS_SCREEN = '/settings';

    static SIGN_IN_SCREEN = '/signin';

    static SOS_SCREEN = '/sos';

    static SPLASH_SCREEN = '/';

    static VIDEO_PLAYER = '/video-player';
}
